import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import SendMessageDialog from './SendMessageDialog';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { selector as sendMessageFormSelector } from './EmailEditorForm';

class SendMessageButton extends Component {
	constructor(props) {
		super(props);
		this.showSendMessageDialog = this.showSendMessageDialog.bind(this);
		this.hideSendMessageDialog = this.hideSendMessageDialog.bind(this);
		this.handleSendMessageDialogConfirm = this.handleSendMessageDialogConfirm.bind(this);

		this.state = {
			showSendMessageDialog: false,
		};
	}

	showSendMessageDialog() {
		this.setState({
			showSendMessageDialog: true
		});
	}

	hideSendMessageDialog() {
		this.setState({
			showSendMessageDialog: false
		});
	}

	handleSendMessageDialogConfirm(values) {
		const { onSendMessage } = this.props;
		onSendMessage(values, () => this.hideSendMessageDialog());
	}

	render() {
		const { to, block, unblock, style, className, iconOnly, text, center, centers, franchisor, centerTemplate,
			franchisorTemplate, customTemplates, selectedTemplateId, isRestrictedUser, tagCatalog, t } = this.props;

		return <React.Fragment>
			<button onClick={this.showSendMessageDialog} className={className || 'btn btn-warning'} style={style} title={iconOnly && (text || t('Parent_SendMessage'))}>
				<FontAwesomeIcon icon={faEnvelope} />{iconOnly ? '' : ` ${text || t('Parent_SendMessage')}`}
			</button>
			<SendMessageDialog show={this.state.showSendMessageDialog}
				to={to}
				centers={center ? [center] : centers}
				isRestrictedUser={isRestrictedUser}
				franchisor={franchisor}
				centerTemplate={centerTemplate}
				franchisorTemplate={franchisorTemplate}
				customTemplates={customTemplates}
				selectedTemplateId={selectedTemplateId }
				tagCatalog={tagCatalog}
				onConfirm={this.handleSendMessageDialogConfirm}
				onCancel={this.hideSendMessageDialog}
				block={block}
				unblock={unblock} />
		</React.Fragment>;
	}
}
const mapStateToProps = (state) => {
	const {
		entities: { centers, adHocMessageTemplates },
		configuration: { franchisor },
		auth: { currentUser }
	} = state;

	return {
		franchisor,
		centers: Object.values(centers),	// centers are loaded on franchisor init
		centerTemplate: adHocMessageTemplates['AdHocEmail.CenterTemplate'],
		franchisorTemplate: adHocMessageTemplates['AdHocEmail.MasterFranchiseeTemplate'],
		customTemplates: Object.keys(adHocMessageTemplates).filter(x => x !== 'AdHocEmail.CenterTemplate' && x !== 'AdHocEmail.MasterFranchiseeTemplate').map(x => adHocMessageTemplates[x]),
		isRestrictedUser: currentUser.isCenterRestricted || currentUser.isFranchiseeRestricted,
		selectedTemplateId: sendMessageFormSelector(state, 'templateId'),
		tagCatalog: state.messageTemplateTags
	};
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SendMessageButton));